const __request = require(`../__request/__request_contentType_json`);

// 国内改签申请详情
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/buyer/dom/manage/change',
    data:data
  }

  return __request(pParameter)
}

